'use client';

import { c as _c } from "react/compiler-runtime";
import { KeyboardEventHandler, RefObject, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { useResizeObserver } from 'usehooks-ts';
import { AnnouncementBackgroundColor, AnnouncementTextColor } from '@/types/amplience';
interface AnnouncementBarProps {
  onCtaClick?: () => void;
  expiryDate?: string;
  children?: React.ReactNode;
  ariaLabel?: string;
  backgroundColor: AnnouncementBackgroundColor;
  textColor: AnnouncementTextColor;
}
export const backgroundColorMap: Record<AnnouncementBackgroundColor, string> = {
  [AnnouncementBackgroundColor.Black]: 'bg-black',
  [AnnouncementBackgroundColor.Red]: 'bg-brand-red-dark',
  [AnnouncementBackgroundColor.LightRed]: 'bg-brand-red-light',
  [AnnouncementBackgroundColor.Blue]: 'bg-brand-blue-dark',
  [AnnouncementBackgroundColor.LightBlue]: 'bg-brand-blue-contrast',
  [AnnouncementBackgroundColor.Green]: 'bg-brand-green-dark',
  [AnnouncementBackgroundColor.LightGreen]: 'bg-brand-green-contrast',
  [AnnouncementBackgroundColor.Pink]: 'bg-brand-pink-contrast',
  [AnnouncementBackgroundColor.Yellow]: 'bg-brand-yellow-contrast'
};
export const textColorMap: Record<AnnouncementTextColor, string> = {
  [AnnouncementTextColor.White]: 'text-white',
  [AnnouncementTextColor.Black]: 'text-black'
};
const AnnouncementBar = t0 => {
  const $ = _c(14);
  const {
    onCtaClick,
    children,
    ariaLabel,
    backgroundColor,
    textColor
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ref: ref as RefObject<HTMLElement>,
      box: "border-box",
      onResize: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useResizeObserver(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useEffect(_temp3, t2);
  let t3;
  if ($[2] !== onCtaClick) {
    t3 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onCtaClick?.();
      }
    };
    $[2] = onCtaClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleKeyDown = t3;
  const t4 = onCtaClick ? "button" : undefined;
  const t5 = backgroundColorMap[backgroundColor];
  const t6 = textColorMap[textColor];
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = clsx("header-banner relative flex size-full w-full shrink-0 basis-full cursor-pointer flex-wrap items-center justify-center gap-1 px-4 py-2 text-sm text-xs outline-none focus-visible:ring-1 focus-visible:ring-offset-1", t5, t6);
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== ariaLabel || $[8] !== children || $[9] !== handleKeyDown || $[10] !== onCtaClick || $[11] !== t4 || $[12] !== t7) {
    t8 = <div ref={ref} role={t4} tabIndex={0} aria-label={ariaLabel} onClick={onCtaClick} onKeyDown={handleKeyDown} className={t7}>{children}</div>;
    $[7] = ariaLabel;
    $[8] = children;
    $[9] = handleKeyDown;
    $[10] = onCtaClick;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default AnnouncementBar;
function _temp(t0) {
  const {
    height
  } = t0;
  document.body.style.setProperty("--header-banner-height", `${height}px`);
}
function _temp2() {
  document.body.style.removeProperty("--header-banner-height");
}
function _temp3() {
  return _temp2;
}